<template>
  <el-dialog
    title="Редактировать заявку"
    :visible="visible"
    width="95%"
    @close="beforeClose()"
  >
    <div class="da_mob">
      <div class="dl_price_ch">
        <el-select v-model="bid_request.driver_id">
          <el-option
            v-for="d in drivers"
            :key="d.id"
            :label="d.fio || '(нет данных)'"
            :value="d.id"
            :class="d.id === bid_request.driver_id ? 'selected' : ''"
          >
            <div class="edit_auto_s">
              <p>
                Организация: <b>{{ d.carrier_name || '(нет данных)' }}</b>
              </p>
              <p>
                Водитель: <b>{{ d.fio || '(нет данных)' }}</b>
              </p>
            </div>
          </el-option>
        </el-select>
        <el-row>
          <el-button type="danger" :loading="loading" @click="deleteAuto">
            Удалить
          </el-button>
          <el-button type="success" :loading="loading" @click="updateAuto">
            Сохранить
          </el-button>
        </el-row>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { GET_FILTER_DRIVERS } from '@/store/actions/drivers'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapGetters, mapMutations } from 'vuex'

const Responses = RepositoryFactory.get('responses')
const Bids = RepositoryFactory.get('bids')

export default {
  name: 'DriverEditMobile',
  props: {
    response: {
      type: Object,
      default: () => {},
    },
    added: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      bid_request: {
        driver_id: this.response.driver_id,
      },
      loading: false,
    }
  },
  computed: {
    ...mapGetters({ driversList: 'drivers/getDrivers' }),
    drivers() {
      let res =
        this.response && this.response.driver ? [this.response.driver] : []

      if (this.driversList && this.driversList.length) {
        res = res.concat(
          this.driversList.filter(d => !this.added.drivers.includes(d.id)),
        )
      }

      return res
    },
  },
  watch: {
    response(newVal) {
      if (newVal && newVal.id) {
        this.beforeOpen(newVal)
      }
    },
  },
  methods: {
    ...mapMutations('loadDay', ['deleteResponse']),
    beforeOpen(response) {
      const { driver_id, auto } = response
      const { carrier_inn } = auto

      this.bid_request = { driver_id }
      this.$store.dispatch(`drivers/${GET_FILTER_DRIVERS}`, { carrier_inn })
    },

    updateAuto() {
      this.loading = true

      Responses.updateResponse(this.response.id, { ...this.bid_request })
        .then(() => this.beforeClose({}))
        .catch(err => this.errHandler(err))
        .finally(() => (this.loading = false))
    },
    deleteAuto() {
      const { bid_id, id } = this.response

      this.$confirm('Вы уверены что хотите отменить заявку?', '', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Отмена',
        type: 'warning',
        customClass: this.isMobile ? 'before-del' : '',
      })
        .then(() => {
          this.loading = true
          Bids.deleteBidRequest(bid_id, id)
            .then(() => {
              this.deleteResponse(id)
              this.beforeClose()
            })
            .catch(err => this.errHandler(err))
            .finally(() => (this.loading = false))
        })
        .catch(() => {})
    },
    beforeClose(r = null) {
      this.$emit('changed', r, false, Boolean(r))
    },
  },
}
</script>

<style lang="sass">
.edit_auto_s
  padding-top: 5px
  p
    margin: 0
    font-size: 12px
    line-height: 1
    width: 200px
</style>
